import React, { useEffect } from 'react'
import { Modal, View, Image, TouchableOpacity, StyleSheet, Platform } from 'react-native'
import { Ionicons } from '@expo/vector-icons'

/**
 * Modal de fullscreen para imágenes en web
 * Solo se renderiza en Platform.OS === 'web'
 */
const ImageFullscreenModal = ({ visible, imageUri, onClose }) => {
    if (Platform.OS !== 'web') {
        return null
    }

    // Cerrar con tecla ESC
    useEffect(() => {
        if (!visible) return
        
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose()
            }
        }
        
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [visible, onClose])

    return (
        <Modal
            visible={visible}
            transparent={true}
            animationType="fade"
            onRequestClose={onClose}
        >
            <View style={styles.modalContainer}>
                {/* Backdrop oscuro */}
                <TouchableOpacity 
                    style={styles.backdrop} 
                    activeOpacity={1}
                    onPress={onClose}
                />
                
                {/* Botón de cerrar */}
                <TouchableOpacity 
                    style={styles.closeButton}
                    onPress={onClose}
                    activeOpacity={0.7}
                >
                    <Ionicons name="close" size={32} color="#fff" />
                </TouchableOpacity>

                {/* Imagen en fullscreen */}
                <View style={styles.imageContainer}>
                    <Image
                        source={{ uri: imageUri }}
                        style={styles.fullscreenImage}
                        resizeMode="contain"
                    />
                </View>
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    modalContainer: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdrop: {
        ...StyleSheet.absoluteFillObject,
        zIndex: 1,
    },
    closeButton: {
        position: 'absolute',
        top: 20,
        right: 20,
        zIndex: 10,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderRadius: 25,
        padding: 8,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    },
    imageContainer: {
        width: '90%',
        height: '90%',
        zIndex: 5,
    },
    fullscreenImage: {
        width: '100%',
        height: '100%',
    },
})

export default ImageFullscreenModal
